import(/* webpackMode: "eager" */ "/app/nettleworth-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/nettleworth-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/app/(charts)/retirement-fund/componets/ClientSideEffects.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/components/LocaleLink.js");
